<template>
    <div id="app">
        <el-main class="el-main">
            <router-view></router-view>
        </el-main>
    </div>
</template>

<script>
import utils from '@/assets/js/utils.js';
    export default {
        name: 'app',
        created(){
            // url上截取domain
            // let localUrl = window.location.href
            // let str1 = localUrl.split(".")[1]
            // let str2 = localUrl.split(".")[2].split("/")[0]
            // let domainName = `.${str1}.${str2}`
            // let cookie = utils.getCookie('loginKey');
        //     if(cookie){
        //         this.axios.get('/userGroup/user-group/rgUser/autoSignIn?service=1',{})
        //         .then(res => {
        //             if(res.status == 200){
        //                 if(res.data.errorCode == '0x0'){
        //                     let {tagList, redirectUrl} = res.data.result;
        //                     if(tagList && tagList.length){
        //                         tagList.forEach( tag => {
        //                             document.cookie = `${tag["tagKey"]}=${tag["tagValue"]}; path=/"; domin=${domainName}`
        //                         });
        //                     }
        //                     if(redirectUrl){
        //                         let url = redirectUrl.indexOf("http") == 0 ? redirectUrl : 'http://'+redirectUrl;
        //                         window.location.href = url;
        //                     }
        //                 }
        //             }else{
        //                 this.$message.error('request failed');
        //             }
        //         })
        //     }
            
        //     // window.location.href = window.location.protocol + '//' + this.StateObj.common.baseUrl.tvuccUrl;
        }
    }
</script>

<style lang='less'>
    .el-main{
        height: 100%;
    }
</style>
